import { useApi } from '@root/src/web/lib/api';
export const useDiscussion = (url) => {
    const { data, loading, error } = useApi(url);
    if (loading || error)
        return {
            commentCount: undefined,
            isClosedForComments: true,
        };
    return {
        commentCount: data?.discussion?.commentCount,
        isClosedForComments: data?.discussion?.isClosedForComments || true,
    };
};
